
import React from "react";
import { SourceAnalytics } from "../SourceAnalytics";
import { TimeToHire } from "../TimeToHire";
import type { Candidate } from "@/components/candidates/types";
import type { AnalyticsConfig } from "../components/AnalyticsSettings";

interface ChartSectionProps {
  candidates: Candidate[];
  settings?: AnalyticsConfig;
}

export const ChartSection = ({ candidates, settings }: ChartSectionProps) => {
  const showSourceAnalytics = settings?.showSourceAnalytics ?? true;
  const showTimeToHire = settings?.showTimeToHire ?? true;

  // If no charts should be shown, display a message
  if (!showSourceAnalytics && !showTimeToHire) {
    return (
      <div className="flex items-center justify-center h-64 text-muted-foreground bg-muted/5 rounded-lg border border-dashed">
        <p>No charts configured to display. Enable charts in Analytics Settings.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {showSourceAnalytics && <SourceAnalytics candidates={candidates} />}
      {showTimeToHire && <TimeToHire candidates={candidates} />}
    </div>
  );
};
